// @ts-nocheck

import React, { FunctionComponent, useState } from 'react'
import { Link } from 'react-router-dom'
import CheckboxAntd from 'Containers/ui/CheckboxAntd'
import { GreenBtn } from 'Stories/Button/Button.stories'
import { calcTimeLeft } from 'Containers/Tracks/helpers'
import { useDispatch, useSelector } from 'react-redux'
import { Desktop } from 'Shared/components/Responsive'
import {
  acceptTrack,
  setID,
  getOfferedCampaigns,
} from 'Redux/actions/influencerActions'
import { getOpenedCampaign } from 'Redux/selectors/influencer'
import { policyLink } from 'Constants/links'

import { ButtonsGroups, ButtonWrapper, Container } from '../styles'
import { PolicyLinks } from './styles'
import { AcceptTrackProps } from './types'

export const AcceptTrack: FunctionComponent<AcceptTrackProps> = ({
  t,
  onClose,
}) => {
  const [policyAccepted, setPolicyAccepted] = useState(false)
  const campaign = useSelector(getOpenedCampaign)
  const dispatch = useDispatch()
  const [accepted, setAccepted] = useState(false)

  const toogleAcceptPolicy = () => setPolicyAccepted(!policyAccepted)

  const timeLeft = calcTimeLeft(campaign?.deadlineToAccept, t)

  const handleClickAccept = () => {
    dispatch(
      acceptTrack(campaign.id, (error, res) => {
        if (!error) {
          setAccepted(true)
          dispatch(setID(res.eventId))
          dispatch(getOfferedCampaigns())
        }
      })
    )
  }

  return (
    <Container>
      <CheckboxAntd
        checked={policyAccepted}
        title={t('influencer.acceptPolicy')}
        onChange={toogleAcceptPolicy}
      />
      <PolicyLinks>
        <Link
          to={{
            pathname: { policyLink },
          }}
          target="_blank"
        >
          {t('influencer.policy')}
        </Link>
        &nbsp;
        {t('influencer.beforeAccepting')}
      </PolicyLinks>

      <ButtonsGroups>
        <Desktop>
          <GreenBtn color="white" onClick={onClose}>
            {t('influencer.closeBtn')}
          </GreenBtn>
        </Desktop>

        <ButtonWrapper>
          <GreenBtn
            color={policyAccepted ? 'green' : 'grey'}
            disabled={!policyAccepted}
            onClick={handleClickAccept}
          >
            {t('influencer.acceptTrack')}
          </GreenBtn>
          <span>{timeLeft}</span>
        </ButtonWrapper>
      </ButtonsGroups>
    </Container>
  )
}
